import {Component, OnDestroy, OnInit} from '@angular/core';
import {PatientService} from '../../services/patient.service';
import {isNull} from 'util';
import {StorageService} from '../../services/storage.service';
import {TrackingService} from '../../services/tracking.service';
import {Router} from '@angular/router';
import {CompteService} from '../../services/compte.service';


@Component({
    selector: 'oap-delivery',
    templateUrl: './delivery.component.html',
    styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit, OnDestroy {

    public commandes;
    public commandesEnCours;
    public commandesAvenir;
    public commandesTerminees;
    public patientId: number;
    public identifiantSAP;
    public subscription;
    public pendingStatus;
    public doubleAuthent = false;
    public phoneNumber: string;
    public smsNumber: string;
    public numberToShow = '';

    constructor(public patientService: PatientService,
                private storageService: StorageService,
                private router: Router,
                private tracking: TrackingService,
                private compteService: CompteService) {
        this.patientService = patientService;
        this.pendingStatus = [
            ['D00', 'D50'], // ordonnance réceptionnée, étape 1
            ['D99', 'D05'], // en cours de préparation, étape 2
            ['D01', 'D02', 'D03', 'D04', 'D06', 'D07', 'D08', 'D09', 'D10', 'D11', 'D12', 'D13', 'D14', 'D15', 'D16', 'D19', 'D20', 'D21', 'D22', 'D24', 'D25', 'D26'], // expédition et livraison en cours, étape 3
        ];
    }

    ngOnInit() {
        if (localStorage.getItem('doubleauthent') === 'false' ) {
            this.router.navigate(['/double-authent']);
        } else {
            this.identifiantSAP = JSON.parse(localStorage.getItem('patientCurrent')).identifiantSAP;
            if (!isNull(this.identifiantSAP)) {
                this.patientService.getPatient(parseInt(localStorage.getItem('patientId'))).subscribe(
                    patient => {
                        this.compteService.getById(patient.compteKey).subscribe((compte: any) => {
                            if (compte.mobile == null) {
                                this.phoneNumber = '';
                            } else {
                                this.phoneNumber = compte.mobile;
                                this.smsNumber = compte.mobile.substring(6);
                                if (this.phoneNumber.length > 3) {
                                    let etoiles = '';
                                    for (let i = 0; i < this.phoneNumber.length - 3; i++) {
                                        etoiles += '*';
                                    }
                                    this.numberToShow = etoiles + this.phoneNumber.substring(this.phoneNumber.length - 3);
                                }
                            }
                        });
                    });
                this.getInfoDelivery();
                this.subscription = this.storageService.watchStorage().subscribe((data: string) => {
                    this.getInfoDelivery();
                });
    
            } else {
                this.patientId = -1;
            }
        }
    }

    ngOnDestroy() {
        if(this.subscription !== undefined) {
            this.subscription.unsubscribe();
        }
    }

    private getInfoDelivery() {
        this.identifiantSAP = JSON.parse(localStorage.getItem('patientCurrent')).identifiantSAP;
        this.patientId = parseInt(localStorage.getItem('patientId'));
        this.patientService.getLivraisonsForPatient(this.patientId).subscribe(
            data => {
                this.commandes = data;
                this.commandesEnCours = this.commandes.en_cours;
                this.commandesAvenir = this.commandes.a_venir;
                this.commandesTerminees = this.commandes.terminees_ok;
                // compute current step for pending deliveries :
                const trackingOrders = [];
                const today = new Date();
                for (const pendingDelivery of this.commandesEnCours) {
                    let currentStep = -1;
                    for (let i = 0; i < this.pendingStatus.length; i ++) {
                        if (this.pendingStatus[i].indexOf(pendingDelivery.codeEtatCommande) > -1) {
                            currentStep = i;
                            if (currentStep === 2) {
                                const dateExpedition = new Date(pendingDelivery.dateExpedition);
                                const diffD = parseInt(((today.getTime() - dateExpedition.getTime()) / (1000 * 3600 * 24)) + '');
                                if (diffD > 15) {
                                    pendingDelivery.sortieTard = true;
                                } else {
                                    pendingDelivery.sortieTard = false;
                                }
                            }
                        }
                    }
                    pendingDelivery.currentStep = currentStep;
                    const productsDuplicates = pendingDelivery.ligneDeCommande.map((line) => {
                        return line.produit;
                    });
                    const products = productsDuplicates;
                    const labels = [
                        'Ordonnance réceptionnée',
                        'En cours de préparation',
                        'Expédition de votre traitement et livraison en cours',
                    ];
                    trackingOrders.push({
                        label: labels[currentStep],
                        products: products,
                        orderID: pendingDelivery.numeroCommande
                    });
                }
                if (trackingOrders.length) {
                    this.tracking.pushDataLayerDelivery('Livraison', 'Suivi de commande', trackingOrders);
                }
            },
            error => console.log(error)
        );
    }


    isEmpty(commande: any) {
        return !!(commande === undefined || commande == null || commande.length === 0);
    }


}
